// Edit to change the header functionality
  // Enabling the code below will:
    // make the mega menu open on hover
    // when clicking the main header items (EX: "Cummins"), user will get redirected to Cummins collection

// With this code disabled below, the theme:
  // Will not navigate to the main header collection
  // Will require the user to click on mega menu subcollection items

// theme.headerMainMenuModule = (function () {
//   function mainMenu() {
//     let menuLiSelector = document.querySelectorAll(".header__menu_li");
//     menuLiSelector.forEach((item) => {
//       if (item.classList.contains("menu__item_has_children")) {
//         let menuItemUrl = "",
//           menuItemLocation = "";
//         item.addEventListener("mouseover", (event) => {
//           let listDetails = item.querySelector("details");
//           listDetails.setAttribute("open", "");
//           item.querySelector("summary").setAttribute("aria-expanded", true);
//         });
//         item.addEventListener("mouseleave", (event) => {
//           let listDetails = item.querySelector("details");
//           listDetails.removeAttribute("open");
//           item.querySelector("summary").setAttribute("aria-expanded", false);
//         });
//         item.querySelector("summary").addEventListener("click", (event) => {
//           event.stopPropagation();
//           menuItemUrl = item.querySelector("summary").dataset.href;
//           menuItemLocation = `${window.location.origin}${menuItemUrl}`;
//           let itemAttr = item.querySelector("details");
//           if (itemAttr.hasAttribute("open")) {
//             location.href = `${menuItemLocation}`;
//           }
//         });
//       }
//     });
//   }
//   return mainMenu;
// })();

// Mega menu functionality
document.addEventListener('DOMContentLoaded', function() {
  const menuContainer = document.querySelector('.header__menu_ul');
  
  if (!menuContainer) return;
 
  // Cache DOM queries
  const menuDetails = document.querySelectorAll('.header__menu_li details');

  // Sync mega menu visibility with details element state
  const syncMegaMenuState = (details) => {
    const megaMenu = details.querySelector('.header__mega_menu');
    if (!megaMenu) return;
    megaMenu.classList.toggle('is-open', details.open);
  };

  // Initialize and sync mega menu states
  menuDetails.forEach((details) => {
    details.addEventListener('toggle', () => syncMegaMenuState(details));
    syncMegaMenuState(details);
  });
  
  // Close all open menu items
  const closeAllMenus = () => {
    const openMenus = document.querySelectorAll('.header__menu_li details[open]');
    openMenus.forEach((details) => {
      details.removeAttribute('open');
      syncMegaMenuState(details);
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  };
  
  // Use event delegation for better performance
  // Handle all clicks within the menu container
  menuContainer.addEventListener('click', function(event) {
    const target = event.target;
    
    // Handle mega menu column clicks (entire column is clickable)
    const megaMenuLi = target.closest('.header__mega_menu_li');
    if (megaMenuLi) {
      // Don't navigate if clicking on a submenu link
      if (target.closest('.header__mega_sub_menu_item')) {
        return; // Let the submenu link handle navigation
      }
      
      // Navigate to the parent category link
      const parentLink = megaMenuLi.querySelector('.header__mega_menu_item');
      if (parentLink && parentLink.href) {
        window.location.href = parentLink.href;
      }
      return;
    }
    
    // Prevent clicks inside mega menu from closing it
    if (target.closest('.header__mega_menu')) {
      event.stopPropagation();
      return;
    }
  });
  
  // Close menus when clicking outside
  document.addEventListener('click', function(event) {
    const clickedInsideMenu = menuContainer.contains(event.target);
    const clickedOnMenuItem = event.target.closest('.header__menu_li');
    
    if (!clickedInsideMenu && !clickedOnMenuItem) {
      closeAllMenus();
    }
  });
});
